module.exports = __webpack_public_path__ + "assets/asset_cubes.f7db6b98.svg";